const REACT_APP_API = process.env.REACT_APP_API;

export { REACT_APP_API };
